import { render, staticRenderFns } from "./BlogDetail.vue?vue&type=template&id=3843d347&scoped=true"
import script from "./BlogDetail.vue?vue&type=script&lang=js"
export * from "./BlogDetail.vue?vue&type=script&lang=js"
import style0 from "./BlogDetail.vue?vue&type=style&index=0&id=3843d347&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3843d347",
  null
  
)

export default component.exports